export default {
  data () {
    return {
      selectedTheme: 'blue',
      theme: {
        blue: {
          strokeColor: '#63c2de',
          shadowColor: '#63c2de',
          shadowStroke: 'white',
          shadowBlur: 5,
          disabledColor: 'lightgrey'
        },
        green: {
          strokeColor: '#4dbd74',
          shadowColor: '#4dbd74',
          shadowStroke: 'white',
          shadowBlur: 5,
          disabledColor: 'lightgrey'
        },
        red: {
          strokeColor: '#f86c6b',
          shadowColor: '#f86c6b',
          shadowStroke: 'white',
          shadowBlur: 5,
          disabledColor: 'lightgrey'
        }
      }
    }
  },

  methods: {
    isThemeSelected (color) {
      return this.selectedTheme === color
    },

    updateTheme (color) {
      if (this.isThemeSelected(color)) { return }
      this.selectedTheme = color
      this.tempLayer.findOne('Rect').setAttr('stroke', this.theme[this.selectedTheme].strokeColor)
      this.tempLayer.draw()
      this.updateShapeColor(this.selectedTheme)
    },

    updateShapeColor () {
      let vm = this
      this.drawLayer.find('Rect').each(function (shape) {
        shape.setAttr('stroke', vm.theme[vm.selectedTheme].strokeColor)
        shape.draw()
      })
      this.drawLayer.draw()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Train/themes.js